/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2024 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../../core/IceEntity';

export class claimrepriced extends IceEntity {
  claim_repriced_key: string = "";
  reference_identification_qualifier: string = "";
  reference_identification: string = "";
  pricing_methodology: string = "";
  allowed_amount: number = 0.0;
  saving_amount: number = 0.0;
  repricing_organization_reference_identification: string = "";
  rate_amount: number = 0.0;
  apg_reference_identification: string = "";
  apg_amount: number = 0.0;
  product_service_id_qualifier: string = "";
  code: string = "";
  modifier1: string = "";
  modifier2: string = "";
  modifier3: string = "";
  modifier4: string = "";
  price: number = 0.0;
  cost: number = 0.0;
  unit_code: string = "";
  quantity: number = 0.0;
  facility_code: string = "";
  emergency_indicator: string = "";
  epsdt_indicator: string = "";
  family_planning_indicator: string = "";
  copay_status_code: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;

  constructor() {
    super();
  }

  gettablename(): string {
    return "CLAIM_REPRICED";
  }
}


